export default [
    {
        path: '/autoevaluation',
        name: 'autoevaluation',
        meta: { requiresAuth: true,
            pageTitle: 'Auto-Evaluation',},
        component: () => import('@/views/evaluation/evaluationsView/EvaluationView.vue'),
      },

      {
        path: '/evaluation',
        name: 'evaluation',
        meta: {
            requiresAuth: true,
            requiresAdminOrHierarchy: true,
            pageTitle: 'Evaluation',
            breadcrumb: [
                {
                    text: 'Liste Evaluations',
                    to: '/hierarchy/evaluation',
                },
                {

                    key: 'evaluation.person',
                    active: true,

                }
            ],
        },
        component: () => import('@/views/evaluation/evaluationsView/EvaluationView.vue'),

      },

    //   {
    //     path: '/all_evaluation_print/:id/:isRapport?',
    //     name: 'all_evaluation_print',
    //      meta: { requiresAuth: true },  // Nécessite une authentification
    //
    //     component: () => import('@/views/evaluation/AllEvaluationForm.vue'),
    //   },
    //
    // {
    //     path: '/evaluation_print/:id',
    //     name: 'evaluation_print',
    //     meta: { requiresAuth: true },  // Nécessite une authentification
    //
    //     component: () => import('@/views/evaluation/EvaluationForm.vue'),
    // },
    // {
    //     path: '/auto_evaluation_print/:id',
    //     name: 'auto_evaluation_print',
    //     meta: { requiresAuth: true },  // Nécessite une authentification
    //
    //     component: () => import('@/views/evaluation/AutoEvaluationForm.vue'),
    // },

    {
        path: '/evaluation_prints/:id/:isRapport?',
        name: 'evaluation_prints',

        meta: { requiresAuth: true,
            // pageTitle: 'Evaluation',
            // breadcrumb: [
            //     {
            //         text: 'Récapitulatif',
            //         // to: '/hierarchy/evaluation',
            //     },
            // ],
        },

        component: () => import('@/views/evaluation/ViewEvaluationForm.vue'),
    },
]
